const Caption = ({content}) => {

    return (<div className="caption" dangerouslySetInnerHTML={ { __html: content } }></div>) 
}

export default Caption;

